import { h } from 'preact';
import * as BaseComp from 'components/bolt/header/headerExpanded.js';
import Store from 'store/store';
import { accessNested } from 'utils/utils';
import { getMainPage, isVideosPage } from 'utils/bolt';
// import s from 'components/bolt/header/headerExpanded.sss';

export default class HeaderExpanded extends BaseComp.default {
	closeAndNavigate(id, e, linkName, queryString) {
		// TODO: Store.emit('CLOSE_AND_NAVIGATE', id, e);
		// TODO: Look into using navigateInternally from utils/bolt ?

		if (e && e.preventDefault) {
			e.preventDefault();
		}

		this.trackNavLink(linkName, id);

		Store.emit('CLOSE_NAV_MENU');
		const groupBookingsEnabled = accessNested(this.props, 'appData.pages.boltShowtimes.data.groupBookings.isEnabled', false);

		// group bookings hack to clear ?booknow and ?groupbookings on other header clicks
		if (groupBookingsEnabled && !queryString && location.search) {
			history.replaceState(null, '', location.pathname);
		}

		if (id.startsWith('@')) {
			Store.emit('OPEN_RESERVED_VARIABLE_LINK', id);
		}

		const page = accessNested(this.props, ['appData', 'pages', id]);
		if (!page) {
			return;
		}

		if (!page.section && !page.type && id !== 'boltHome') {
			Store.emit('CLOSE_ALL_OVERLAYS');
			Store.emit('SET_ACTIVE_PAGE', id);
			return;
		}

		if (page.type === 'showtimes') {
			if (this.props.isCalendarRemindMode) {
				Store.emit('SET_ACTIVE_PAGE', getMainPage());
				Store.emit('SHOW_CAL_REMIND');
			} else {
				Store.emit('SHOWTIMES_SHOW', undefined, queryString, id);
			}
		} else if (page.type === 'homeEnt') {
			Store.emit('HOMEENT_SHOW', undefined, undefined, id);
		} else if (page.type === 'pressKit') {
			Store.emit('PRESSKIT_SHOW', undefined, undefined, id);
		} else if (isVideosPage(id)) {
			Store.emit('OPEN_VIDEO_OVERLAY', id);
		} else if (page.parent && page.parent === Store.get().activePage) {
			// if the destination page is a child of the currently active page, just scroll to destination section
			Store.emit('CHANGE_ACTIVE_SECTION', page.id);
		} else if (page.parent) {
			// if the destination page is a child of a page that is not the currently active page, 
			// navigate to the parent page then scroll to the destination section
			//find hashinpage
			const hashInPage = '#' + page.path.replaceAll('/', '');
			Store.emit('CLOSE_ALL_OVERLAYS');
			Store.emit('SET_ACTIVE_PAGE', page.parent, null, { hashInPage });
		} else {
			Store.emit('CLOSE_ALL_OVERLAYS');
			Store.emit('SET_ACTIVE_PAGE', id);
			Store.emit('CHANGE_ACTIVE_SECTION', id, { instant: true, mainPage: getMainPage() });
			if (page.type === 'stickAndScaleWidget') {
				Store.emit('EXPAND_WIDGET');
			}
		}
	}
}
